// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-restricted-container[data-v-a6a930e8]{padding:10px 5px;flex-direction:column}.is-restricted-container[data-v-a6a930e8],.is-restricted-upper-message[data-v-a6a930e8]{display:flex;justify-content:center;align-items:center}.is-restricted-upper-message[data-v-a6a930e8]{color:#dd2d01;font-size:16px;padding-bottom:10px}.is-restricted-lower-message[data-v-a6a930e8]{font-size:13px;color:#9f434e}.is-restricted-success-msg[data-v-a6a930e8]{color:#4aac4f;font-size:13px}", ""]);
// Exports
module.exports = exports;
